import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import App from "./App";
import { ThemeProvider, bootstrapTheme } from "./hooks/useTheme";
import "./i18n"; // Bootstraps i18next with EN-first fallback (ADR-i18n-react-i18next-en-first)
import "./index.css";

// Apply persisted theme synchronously to avoid dark-flash on first paint
// when the user has selected "light" in a previous session.
bootstrapTheme();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
  },
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </ThemeProvider>
  </StrictMode>
);
